import {
  SWATCH_BRONZE,
  PRIMARY_COLOR,
  PRIMARY_BACKGROUND,
  TEXT_PRIMARY_BRAND,
  BORDER_PRIMARY,
  PRIMARY_DARK,
  TERNARY_DARK,
} from './boldstuff-color-constants.js';

// Derived from primary brand hex (46, 97, A0)
const PRIMARY_RGB = '70, 151, 160';

if (typeof document !== 'undefined') {
  document.documentElement.style.setProperty('--swatch-bronze', SWATCH_BRONZE);
  document.documentElement.style.setProperty('--PRIMARY_COLOR', PRIMARY_COLOR);
  document.documentElement.style.setProperty('--PRIMARY_BACKGROUND', PRIMARY_BACKGROUND);
  document.documentElement.style.setProperty('--TEXT_PRIMARY_BRAND', TEXT_PRIMARY_BRAND);
  document.documentElement.style.setProperty('--BORDER_PRIMARY', BORDER_PRIMARY);
  document.documentElement.style.setProperty('--border-primary', BORDER_PRIMARY);
  document.documentElement.style.setProperty('--primary-dark', PRIMARY_DARK);
  document.documentElement.style.setProperty('--ternary-dark', TERNARY_DARK);

  // Used for rgba(...) colors where alpha varies.
  document.documentElement.style.setProperty('--PRIMARY_COLOR_RGB', PRIMARY_RGB);
  document.documentElement.style.setProperty('--PRIMARY_BACKGROUND_RGB', PRIMARY_RGB);
  document.documentElement.style.setProperty('--TEXT_PRIMARY_BRAND_RGB', PRIMARY_RGB);
  document.documentElement.style.setProperty('--BORDER_PRIMARY_RGB', PRIMARY_RGB);
}

if (typeof window !== 'undefined') {
  window.BOLDSTUFF_COLORS = {
    SWATCH_BRONZE,
    PRIMARY_COLOR,
    PRIMARY_BACKGROUND,
    TEXT_PRIMARY_BRAND,
    BORDER_PRIMARY,
  };
}
